import React, { useState, useEffect } from "react";
import axios from "axios";
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import Home_facebook from './home_facebook.jsx';
import Home_tiktok from './home_tiktok.jsx';
import Home_youtube from './home_youtube.jsx';
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import Post_content from '../../../community/content/Blog_posts.jsx';
const MyComponent = () => {
    const { slug_1, slug_2 } = useParams();
    // alert(slug_1);
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const [point_vipig, set_point_vipig] = useState('');
    const checktk = () => {
        const myCookieValue = Cookies.get('apikey');
        axios.post('https://hust.media/insta/profile.php', {
            key: myCookieValue,
            chedo: 'kiemtradangnhap',
            social: slug_1
        })
            .then(response => {
                asdasdkas(response.data);
            })
            .catch(error => console.log(error));
    };
    const asdasdkas = (info) => {
        console.log(info.status);
        if (info.status == 0) {
            alert_error(info.message);
        }
        else if (info.status == 1) {
            alert_success(info.message);
            set_point_vipig(info.sodiem);
            console.log(info.sodiem);
        } else {
            if (info.status == 3) {
                alert_success('Vui lòng thêm tài khoản chéo tiktok');
                switch_router('/reactapp/insta/themcauhinh');
            } else if (info.status == 4) {
                alert_error(info.message);
                switch_router('/shop/wallet/donate');
            }
        }
        if (info.redirect) {
            alert_error(info.message);
            switch_router(info.redirect);
        }
    };
    useEffect(() => {
        checktk();
    }, []);
    return (
        <div>
            <div id="hientruyen"></div>
            <div className="max-w-2xl px-1 py-4 mx-auto rounded-lg shadow-xl">
                {/* Placeholder for data loading spinner */}
                {point_vipig === '' ?
                    (<>
                        <div className="container-fluid">
                            <div className="row bg-pink-200">
                                <p className="text-center text-white">
                                    <div className="text-center spinner-border" role="status"></div>
                                    <br />
                                    Đang tải danh sách
                                </p>
                            </div>
                        </div>
                    </>
                    ) : (<>
                        {/* Placeholder for data */}
                        <div className="row fixrow">
                            <div className="text-center">
                                <Link
                                    type="button"
                                    className="mx-2 btn btn-primary"
                                    to="/reactapp/exchangepoints?webappmode=showadview"
                                >
                                    Chuyển điểm sang Coins
                                </Link>
                                <div>
                                    Số điểm hiện tại là {point_vipig}
                                </div>
                            </div>

                            <div className="mt-0">
                                <div className="grid grid-cols-2 gap-1">
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/insta/themcauhinh" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://cdn-icons-png.flaticon.com/512/992/992651.png"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        Thêm tài khoản chéo {slug_1}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        Đầu tiên bạn vô đây nhé →
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{ textDecoration: 'none' }} to={"/reactapp/sunflower/" + slug_1 + "/listcauhinh"} className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPPeznG6LK16yZ70cv9p-KcIITtk6ASnWOUA&usqp=CAU"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        Chọn Tài khoản làm nhiệm vụ
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        Để chọn tài khoản bạn dùng để Follow →
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {
                                slug_1 == 'facebook' && (<>
                                    <Home_facebook />
                                </>)
                            }
                            {
                                slug_1 == 'tiktok' && (<>
                                    <Home_tiktok />
                                </>)
                            }
                            {
                                slug_1 == 'youtube' && (<>
                                    <Home_youtube />
                                </>)
                            }

                            <Post_content mode={'hust_media'} show_adsense={'YES'} show_adskeeper={'NO'} uri={'p2p_social_partner'} />

                        </div>
                    </>)}
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default MyComponent;
